// extracted by mini-css-extract-plugin
export var column = "_qr-0";
export var divider = "_qr-2";
export var timePicker = "_qr-1";